import React, { FormEvent, useState } from 'react';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModelGroupType } from '../../Models.constants';
import { VisualPicker } from '../../../../../CommonComponents/OPL/VisualPicker/VisualPicker';

interface Option {
  value: ModelGroupType;
  label: string;
  action(): void;
}

interface Props {
  options: Option[];
  onClose(): void;
}

export const SelectModelGroupType: React.FC<Props> = ({ options, onClose }) => {
  const [selectedModelGroupType, setSelectedModelGroupType] = useState<ModelGroupType>(
    ModelGroupType.Orion,
  );

  const handleSubmit = (evt: FormEvent) => {
    evt.preventDefault();

    const foundOption = options.find(({ value }) => value === selectedModelGroupType);

    if (foundOption) {
      foundOption.action();

      onClose();
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} contentLabel="Create Model Group">
      <form onSubmit={handleSubmit}>
        <ModalHeader>Create Model Group</ModalHeader>

        <ModalCloseButton onClick={onClose} />

        <ModalBody css="padding-bottom: 12px">
          <Box display="flex" flexDirection="column">
            {options.map(({ value, label }, index) => (
              <VisualPicker
                key={value}
                checked={selectedModelGroupType === value}
                label={label}
                onChange={() => setSelectedModelGroupType(value)}
                autoFocus={index === 0}
                mt={index === 0 ? '0' : '16'}
              />
            ))}
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button variant="subtleInactive" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="primary" ml="12" type="submit">
            Continue
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
